import axios from 'config/axios'

const TicketServices = {
  getCounts: async () => {
    const { data } = await axios.get('admin/tickets/counts')
    return data
  },
  getUnreadSummary: async () => {
    const { data } = await axios.get('admin/tickets/unread-summary')
    return data
  },
  getTickets: async (params) => {
    const { data } = await axios.get('admin/tickets', { params })
    return data
  },
  getTicketDetail: async (id) => {
    const { data } = await axios.get(`admin/tickets/${id}`)
    return data
  },
  replyTicket: async (id, formData) => {
    const { data } = await axios.post(`admin/tickets/${id}/reply`, formData)
    return data
  },
  changeStatus: async (id, payload) => {
    const { data } = await axios.post(`admin/tickets/${id}/status`, payload)
    return data
  }
}

export default TicketServices
